import type { Artifact } from "@/services/api/agentic-v2";

export function configIdFromPreviewUrl(url: string | null | undefined): string | null {
  const text = url?.trim();
  if (!text) return null;
  try {
    const parsed = text.startsWith("/")
      ? new URL(text, window.location.origin)
      : new URL(text);
    const config = parsed.searchParams.get("config")?.trim();
    return config || null;
  } catch {
    return null;
  }
}

export function reportConfigIdFromArtifact(artifact: Artifact): string | null {
  const reportBuilder = artifact.storage?.report_builder ?? null;
  const metadata = artifact.metadata as
    | { config_id?: string; report_config_id?: string }
    | undefined;
  return (
    reportBuilder?.config_id?.trim()
    ?? metadata?.config_id?.trim()
    ?? metadata?.report_config_id?.trim()
    ?? reportBuilder?.report_id?.trim()
    ?? configIdFromPreviewUrl(reportBuilder?.viewer_url)
    ?? configIdFromPreviewUrl(reportBuilder?.view_url)
    ?? null
  );
}

/** Same-origin URL safe for embedding in an iframe (Agent Review preview). */
export function artifactInlineReportPreviewUrl(artifact: Artifact): string | null {
  const configId = reportConfigIdFromArtifact(artifact);
  if (configId) {
    return `/pdf?template=report-builder&config=${configId}`;
  }
  const blobUrl = artifact.storage?.azure?.blob_url;
  if (blobUrl) return blobUrl;
  return null;
}

/** Rendered report-builder viewer URL (holdings / charts populate here). */
export function artifactReportViewerUrl(artifact: Artifact): string | null {
  const inline = artifactInlineReportPreviewUrl(artifact);
  if (inline) return inline;

  const reportBuilder = artifact.storage?.report_builder ?? null;
  const fromStorage = reportBuilder?.viewer_url ?? reportBuilder?.view_url ?? null;
  return fromStorage;
}
